import { render, staticRenderFns } from "./mobile-change.vue?vue&type=template&id=b2c98d60&scoped=true&"
import script from "./mobile-change.vue?vue&type=script&lang=js&"
export * from "./mobile-change.vue?vue&type=script&lang=js&"
import style0 from "./mobile-change.vue?vue&type=style&index=0&id=b2c98d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c98d60",
  null
  
)

export default component.exports